<template>
    <div class="tags-view">
        <ScrollPane class="tags-view-wrapper">
            <router-link
                class="tags-item"
                tag="span"
                v-for="view in visitedViews"
                :key="view.path"
                :class="isActive(view)?'active':''"
                :to="{ path: view.path, query: view.query, fullPath: view.fullPath }"
                @contextmenu.prevent.native="openMenu(view, $event)">
                {{view.meta.title}}
                <span class="dot-num" v-if="navNumData[view.name]>0&&navNumData[view.name]<99">{{navNumData[view.name]}}</span>
                <span class="dot-num-more" v-if="navNumData[view.name]>99">{{navNumData[view.name]}}</span>
                <span v-if="visitedViews.length > 1" class="el-icon-close" @click.prevent.stop="handleViewDelete(view)" />
            </router-link>
        </ScrollPane>
        <ul v-show="visible" :style="{left:left+'px',top:top+'px'}" class="contextmenu">
            <!-- <li @click="handleRefreshView(selectedTag)">刷新</li> -->
            <li v-if="visitedViews.length > 1" @click="handleViewDelete(selectedTag)">关闭</li>
            <li @click="handleViewDeleteOther(selectedTag)">关闭其他</li>
        </ul>
        <!-- <ul v-show="visible" :style="{left:left+'px',top:top+'px'}" class="contextmenu">
            <li @click="refreshSelectedTag(selectedTag)">刷新</li>
            <li @click="closeSelectedTag(selectedTag)">关闭</li>
            <li @click="closeOthersTags">关闭其它</li>
            <li @click="closeAllTags">关闭所有</li>
        </ul>  -->
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import * as constants from '@/common/constants';
    export default {
        data () {
            return {
                visible: false,
                top: 0,
                left: 0,
                selectedTag: {}
            };
        },
        watch: {
            $route () {
                this.addView(this.$route);
                // this.moveToCurrentTag()
            },
            visible (value) {
                if (value) {
                    document.body.addEventListener('click', this.closeMenu);
                } else {
                    document.body.removeEventListener('click', this.closeMenu);
                }
            }
        },
        props: {
            initPage: {
                type: String
            }
        },
        computed: {
            ...mapGetters([
                'visitedViews',
                'navNumData'
            ])
            // visitedViews() {
            //     return this.$store.state.tagsView.visitedViews
            // }
        },
        mounted () {
            if (this.initPage) {
                this.handleViewDelete(this.$route);
                this.$router.push(this.initPage);
            } else {
                this.addView(this.$route);
            }
        },
        methods: {
            isActive (route) {
                return route.path === this.$route.path;
            },
            ...mapActions([
                constants.VUEX_ACTIONS_TAGS_VIEW_ADD,
                constants.VUEX_ACTIONS_TAGS_VIEW_DELETE,
                constants.VUEX_ACTIONS_TAGS_VIEW_DELETE_OTHER
            ]),
            addView (view) {
                this[constants.VUEX_ACTIONS_TAGS_VIEW_ADD](view);
            },
            async handleViewDelete (view) {
                let visitedViews = await this[constants.VUEX_ACTIONS_TAGS_VIEW_DELETE](view);
                if (this.isActive(view)) {
                    const latestView = visitedViews.slice(-1)[0];
                    if (latestView) {
                        this.$router.push(latestView.path);
                    } else {
                        this.$router.push('/');
                    }
                }
            },
            async handleViewDeleteOther (view) {
                let visitedViews = await this[constants.VUEX_ACTIONS_TAGS_VIEW_DELETE_OTHER](this.selectedTag);
                const latestView = visitedViews.slice(-1)[0];
                if (latestView) {
                    this.$router.push(latestView.path);
                } else {
                    this.$router.push('/');
                }
            },
            async handleRefreshView (view) {
                await this.handleViewDelete(view);
                const { fullPath } = view;
                this.$nextTick(() => {
                    this.$router.replace({
                        path: fullPath
                    });
                });
            },
            moveToCurrentTag () {
                const tags = this.$refs.tag;
                this.$nextTick(() => {
                    for (const tag of tags) {
                        if (tag.to.path === this.$route.path) {
                            this.$refs.scrollPane.moveToTarget(tag);
                            // when query is different then update
                            if (tag.to.fullPath !== this.$route.fullPath) {
                                this.$store.dispatch('updateVisitedView', this.$route);
                            }
                            break;
                        }
                    }
                });
            },
            openMenu (tag, e) {
                const menuMinWidth = 105;
                const offsetLeft = this.$el.getBoundingClientRect().left; // container margin left
                const offsetWidth = this.$el.offsetWidth; // container width
                const maxLeft = offsetWidth - menuMinWidth; // left boundary
                const left = e.clientX - offsetLeft; // 15: margin right

                if (left > maxLeft) {
                    this.left = maxLeft;
                } else {
                    this.left = left;
                }

                this.top = 20;
                this.visible = true;
                this.selectedTag = tag;
            },
            closeMenu () {
                this.visible = false;
            },
            setDefault (initPage) {
                // this.handleViewDelete(this.$route);
                this.$router.push(initPage);
            }
        }
    };
</script>

<style lang="less">
    .tags-view {
        position: relative;
        height: 34px;
        line-height: 34px;
        width: 100%;
        background: #fff;
        border-bottom: 1px solid #d8dce5;
        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .12), 0 0 3px 0 rgba(0, 0, 0, .04);
        .tags-view-wrapper {
            // width: 100%;
            // display: flex;
        }
        .tags-item {
            display: inline-block;
            cursor: pointer;
            height: 26px;
            line-height: 26px;
            border: 1px solid #d8dce5;
            color: #495060;
            background: #fff;
            font-size: 12px;
            padding: 0 8px;
            margin-left: 5px;
            margin-top: 4px;
            &:first-of-type {
                margin-left: 5px;
            }
            &:last-of-type {
                margin-right: 15px;
            }
            &.active {
                background-color: #409eff;
                color: #fff;
                border-color: #409eff;
                &::before {
                    content: '';
                    background: #fff;
                    display: inline-block;
                    width: 8px;
                    height: 8px;
                    border-radius: 50%;
                    position: relative;
                    margin-right: 2px;
                }
            }
        }

        .el-icon-close {
            width: 16px;
            height: 16px;
            vertical-align: 2px;
            border-radius: 50%;
            text-align: center;
            transition: all .3s cubic-bezier(.645, .045, .355, 1);
            transform-origin: 100% 50%;
            &:before {
                transform: scale(.6);
                display: inline-block;
                vertical-align: -3px;
            }
            &:hover {
                background-color: #b4bccc;
                color: #fff;
            }
        }
        .dot-num{
            width: 16px;
            height: 16px;
            border-radius: 9px;
            line-height: 16px;
            background-color: #ff5722;
            color: #FFFFFF;
            display: inline-block;
            text-align: center;
            transform:scale(0.8);
            padding: 2px;
        }
        .dot-num-more{
            width: 30px;
            height: 16px;
            border-radius: 9px;
            line-height: 16px;
            background-color: #ff5722;
            color: #FFFFFF;
            display: inline-block;
            text-align: center;
            transform:scale(0.8);
            padding: 2px;
        }
         .contextmenu {
            margin: 0;
            background: #fff;
            z-index: 100;
            position: absolute;
            list-style-type: none;
            padding: 5px 0;
            border-radius: 4px;
            font-size: 12px;
            font-weight: 400;
            color: #333;
            box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, .3);
            li {
                margin: 0;
                padding: 7px 16px;
                height: 20px;
                line-height: 20px;
                cursor: pointer;
                &:hover {
                    background: #eee;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/TagsView/TagsView.vue